import Vuex from 'vuex';

import session from './modules/session';
import chat from './modules/chat';
import calendar from './modules/calendar';
import goal from './modules/goal';
import clients from './modules/clients';
import products from './modules/products';
import sales from './modules/sales';
import recordings from './modules/recordings';
import metrics from './modules/metrics';
import realtime from './modules/realtime';
import payment from './modules/payment';
import modal from './modules/modal';
import user from './modules/user';
import financial from './modules/financial';
import employeeMetricScope from './plugins/employeeMetricScope';
import service from './modules/service';
import configuration from './modules/configuration';

export default new Vuex.Store({
    plugins: [employeeMetricScope],

    modules: {
        session,
        chat,
        calendar,
        goal,
        clients,
        products,
        sales,
        recordings,
        metrics,
        realtime,
        payment,
        modal,
        user,
        financial,
        service,
        configuration,
    }

});
